export default "__VITE_ASSET__DB$QewAk__"